import {
  PetsTokenList,
  RoleTokenList,
  LootTokenList,
} from "../../../model/rolePlus";

const gender = ["Male", "Female", "Unknown"];
const races = ["Human", "Elf", "Orc", "Undead", "Demons", "Deity"];

const findIndexIPFS = (g: string, e: string) => {
  return (
    String(races.findIndex((i) => i === e)) +
    (g === "Unknown" ? "0" : String(gender.findIndex((i) => i === g)))
  );
};

export default function RolePlusSVG({
  petsInfo,
  roleInfo,
  lootInfo,
  bgUrl,
}: {
  petsInfo: PetsTokenList;
  roleInfo: RoleTokenList;
  lootInfo: LootTokenList;
  bgUrl?: string | undefined;
}) {
  const baseIPFS = `https://ipfs.io/ipfs/QmSLhQXyNgNL6JCq1Vvy3Dhun9Ewar2fr7tfMNtwKX2qzh/${findIndexIPFS(
    roleInfo.gender,
    roleInfo.races
  )}.svg`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 350 350"
    >
      <defs>
        <clipPath id="clip-path">
          <rect className="cls-1" width="350" height="350" />
        </clipPath>
      </defs>
      <g className="cls-2">
        <g id="role">
          <rect className="cls-3" width="350" height="350" />
          <rect className="cls-4" width="350" height="350" />
          {roleInfo.gender && roleInfo.races && (
            <image
              x="12%"
              y="10"
              height="330"
              xlinkHref={bgUrl ? bgUrl : baseIPFS}
            />
          )}
          <image
            x="60%"
            y="250"
            width="40%"
            xlinkHref="https://ipfs.io/ipfs/QmSLhQXyNgNL6JCq1Vvy3Dhun9Ewar2fr7tfMNtwKX2qzh/pet.svg"
          />
          <path
            className="cls-5"
            d="M33.71,12.44a7.39,7.39,0,0,1-5.23-2.16L26,7.81a1.06,1.06,0,0,0-.77-.32v3.67a1.07,1.07,0,0,1,1.07,1.07v1.2a1.88,1.88,0,0,0,1.88,1.87h.64a1.07,1.07,0,1,1,0,2.13h-.64a1.89,1.89,0,0,0-1.87,1.88V26.8a1.08,1.08,0,0,1-1.07,1.07v3.67A9.54,9.54,0,0,0,34.81,22V13.51A1.09,1.09,0,0,0,33.71,12.44Z"
          />
          <path
            className="cls-5"
            d="M25.26,27.85a1.07,1.07,0,0,1-1.06-1.06v-7.5a1.88,1.88,0,0,0-1.88-1.87h-.64a1.07,1.07,0,0,1,0-2.14h.64A1.88,1.88,0,0,0,24.2,13.4V12.2a1.07,1.07,0,0,1,1.06-1.06V7.49a1.05,1.05,0,0,0-.76.32L22,10.28a7.33,7.33,0,0,1-5.23,2.16,1.08,1.08,0,0,0-1.08,1.09V22a9.54,9.54,0,0,0,9.54,9.54V27.85Z"
          />
          <rect className="cls-6" y="265" width="18" height="42" />
          <line className="cls-7" x1="18" y1="265.5" x2="95.5" y2="265.5" />
          <line className="cls-7" x1="18" y1="306.5" x2="181.5" y2="306.5" />
          <g>
            <rect className="cls-8" x="248" y="251" width="91" height="17" />
          </g>
          <g>
            <rect className="cls-8" x="248" y="270" width="91" height="17" />
          </g>
          <g>
            <rect className="cls-8" x="248" y="289" width="91" height="17" />
          </g>
          <g>
            <rect className="cls-8" x="248" y="308" width="91" height="17" />
          </g>
          <g>
            <rect className="cls-8" x="248" y="327" width="91" height="17" />
          </g>
          <g>
            <rect className="cls-8" x="11" y="152" width="88" height="17" />
          </g>
          <g>
            <rect className="cls-8" x="11" y="174" width="88" height="17" />
          </g>
          <g>
            <rect className="cls-8" x="11" y="196" width="88" height="17" />
          </g>
          <g>
            <rect className="cls-8" x="11" y="218" width="88" height="17" />
          </g>
          <g>
            <rect className="cls-8" x="11" y="240" width="88" height="17" />
          </g>
          <rect className="cls-8" x="248" y="12" width="91" height="20" />
          <rect className="cls-8" x="248" y="36" width="91" height="20" />
          <rect className="cls-8" x="248" y="60" width="91" height="20" />
          <rect className="cls-8" x="248" y="84" width="91" height="20" />
          <rect className="cls-8" x="248" y="108" width="91" height="20" />
          <rect className="cls-8" x="248" y="132" width="91" height="20" />
          <rect className="cls-8" x="248" y="156" width="91" height="20" />
          <rect className="cls-8" x="248" y="180" width="91" height="20" />
          <path
            className="cls-5"
            d="M12.11,36.17l.5,64.53h-1l-.51-64.56Zm.49,63.45.32,42.16-1,0-.33-42.18Z"
          />
          <path className="cls-9" d="M292.12,232.66l40.42-.3,0,1-40.45.3Z" />
        </g>
      </g>
      <text className="cls-10" transform="translate(15.94 164.08)">
        {roleInfo.alignment}
      </text>
      <text className="cls-10" transform="translate(254.2 24.56)">
        {lootInfo.chest}
      </text>
      <text className="cls-10" transform="translate(254.2 48.5)">
        {lootInfo.foot}
      </text>
      <text className="cls-10" transform="translate(254.2 72.28)">
        {lootInfo.hand}
      </text>
      <text className="cls-10" transform="translate(254.2 97.22)">
        {lootInfo.head}
      </text>
      <text className="cls-10" transform="translate(254.2 120.67)">
        {lootInfo.neck}
      </text>
      <text className="cls-10" transform="translate(254.2 144.72)">
        {lootInfo.ring}
      </text>
      <text className="cls-10" transform="translate(254.2 169)">
        {lootInfo.waist}
      </text>
      <text className="cls-10" transform="translate(254.2 193.05)">
        {lootInfo.weapon}
      </text>
      <text className="cls-10" transform="translate(254.2 263.46)">
        {petsInfo.alignment}
      </text>
      <text className="cls-10" transform="translate(254.2 281.13)">
        {petsInfo.species}
      </text>
      <text className="cls-10" transform="translate(254.2 300.61)">
        {petsInfo.trait1}
      </text>
      <text className="cls-10" transform="translate(254.2 319.26)">
        {petsInfo.trait2}
      </text>
      <text className="cls-10" transform="translate(254.2 339.08)">
        {petsInfo.trait3}
      </text>
      <text className="cls-10" transform="translate(15.94 185.66)">
        {roleInfo.occupation}
      </text>
      <text className="cls-10" transform="translate(15.94 207.7)">
        {roleInfo.trait1}
      </text>
      <text className="cls-10" transform="translate(15.94 229.94)">
        {roleInfo.trait2}
      </text>
      <text className="cls-10" transform="translate(15.94 251.62)">
        {roleInfo.trait3}
      </text>
      <text className="cls-11" transform="translate(136.13 303.28)">
        {roleInfo.id}
      </text>
      <text className="cls-12" transform="translate(21.56 304.54)">
        Role
      </text>
      <text className="cls-13" transform="translate(19.68 100.41) rotate(90)">
        {lootInfo.id}
      </text>
      <text className="cls-14" transform="translate(19.32 35.87) rotate(90)">
        Loot
      </text>
      <text className="cls-15" transform="translate(293.48 243.74)">
        {petsInfo.id}
      </text>
      <text className="cls-16" transform="translate(288.63 228.13)">
        Pet
      </text>
    </svg>
  );
}
